<button class="btn btn-primary btn-sm" (click)="openModal()" style="width: 100%;">{{title}}</button>

<ng-template #ReleaseItemModal>
  <div class="modal-header">
    <h5 class="modal-title">Add From Sales Release</h5>
    <button type="button" class="btn-close" (click)="ReleaseModalRef.close()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label for="roleName" class="form-label">Sales Release No<span style="color: red;">*</span></label>
      <ng-select (search)="SearchSalesRelease($event)" [items]="SalesReleaseList" bindValue="releaseId" [loading]="searchLoading"
        bindLabel="releaseNo" [formControl]="SalesReleaseNo">

      </ng-select>
    </div>
    <div class="mb-3">
      <!-- <app-uic-color-table [uicListData]="prdListUIC" [tableData]="ReleaseItems" [DataLoading]="dataLoading"
        [enableActionColumn]="false" [enableAutoSerial]="false" [actionColumnLabel]="'Action'"
        [EnableMultiSelect]="true" (selectionCheckBoxEvent)="handleItemSelection($event)">
      </app-uic-color-table> -->

      <div class="table-wrapper card">
        <table class="row-border hover table table-bordered com_table" style="width: 100%;">
          <thead>
            <tr class="text-dark" style="border-left: 5px solid var(--bs-primary);">
              <th scope="col">
                <input type="checkbox" [checked]="isAllChecked()"(change)="toggleAll($event)"></th>
              <th scope="col">Item</th>
              <th scope="col">Price
                <input type="number" class="form-control form-control-sm mt-1" placeholder="Set all" (input)="changeAllPrices($event)" *ngIf="SelectedReleaseItems.length > 0 && EnablePriceEdit">
              </th>
            </tr>
          </thead>
          <tbody id="TemplateListBody">
            <tr *ngFor="let items of ReleaseItems">
              <td>
                <input type="checkbox" [checked]="items.isSelected" (change)="onSelctionCheckboxChange($event,items)">
              </td>
              <td>{{items.itemNo}}</td>
              <td style="width: 150px;">
                <input type="number" class="form-control form-control-sm" *ngIf="items.isSelected && EnablePriceEdit"
                  [(ngModel)]="items.price">
              </td>
            </tr>
            <tr *ngIf="dataLoading">
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <!-- <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader></td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer text-end">
    <button class="btn btn-sm btn-primary" [disabled]="isSubmitting" (click)="submitResults()">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm  me-1" role="status" aria-hidden="true"></span>
      <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span></button>
    <button class="btn btn-sm btn-secondary" (click)="ReleaseModalRef.close()">Close</button>
  </div>
</ng-template>